<ng-container *transloco="let t">

  @for (reason of reasons; track reason; let i = $index) {
    <div [class]="i % 2 === 0 ? 'reason' : 'reason reverse-on-large'">
      <div class="reason__text">
        <h2 class="title" [innerHTML]="reason.title"></h2>
        <p class="reason__text__description" [innerHTML]="reason.description"></p>
      </div>
      <div class="reason__template">
        @if (i === 0) {
          <ng-container *ngTemplateOutlet="template1"></ng-container>
        }
        @if (i === 1) {
          <ng-container *ngTemplateOutlet="template2"></ng-container>
        }
        @if (i === 2) {
          <ng-container *ngTemplateOutlet="template3"></ng-container>
        }
      </div>
    </div>
  }

  <ng-template #template1>
    <div class="gradient-background --middle --left"></div>
    <img class="template-1__iphone" src="assets/img/home-fan/iphone-background.png">
    <img class="template-1__notification" src="assets/img/home-fan/iphone-notification.png">
  </ng-template>

  <ng-template #template2>
    <div class="gradient-background --bottom --left"></div>
    <mat-card class="template-2__frame">
      <mat-card-content>
        <div class="template-2__frame__content">
          <span class="template-2__frame__content__name">Aël LE GUEN</span>
          <img class="template-2__frame__content__img-code" src="assets/img/home-fan/barcode-1.svg">
          <span class="template-2__frame__content__barcode">35000</span>
        </div>
        <div class="template-2__frame__content --new">
          <span class="template-2__frame__content__name">Elouan LE DU</span>
          <img class="template-2__frame__content__img-code" src="assets/img/home-fan/barcode-2.svg">
          <span class="template-2__frame__content__barcode">432222</span>
        </div>
      </mat-card-content>
    </mat-card>
  </ng-template>

  <ng-template #template3>
    <div class="gradient-background --top --right"></div>
    <mat-card class="template-3__frame">
      <mat-card-content>
        <div class="template-3__frame__content --first">
          <div class="template-3__frame__content__text">
            {{ t('fanReasons.whatPrice') }}
          </div>
          <div class="template-3__frame__content__field">
            <span class="template-3__frame__content__field__value">1500</span>
            <mat-icon class="template-3__frame__content__field__euro">euro</mat-icon>
          </div>
        </div>
        <div class="template-3__frame__content --second">
          <mat-icon class="template-3__frame__content__icon reelax-red">close</mat-icon>
          <div class="template-3__frame__content__text">
            {{ t('fanReasons.cannotSaleOverFaceValue') }}
          </div>
        </div>
        <div class="template-3__frame__content --third">
          <div class="template-3__frame__content__text">
            {{ t('fanReasons.whatPrice') }}
          </div>
          <div class="template-3__frame__content__field">
            <span class="template-3__frame__content__field__value">25</span>
            <mat-icon class="template-3__frame__content__field__euro">euro</mat-icon>
          </div>
        </div>
        <div class="template-3__frame__content --fourth">
          <mat-icon class="template-3__frame__content__icon reelax-green">check</mat-icon>
          <div class="template-3__frame__content__text">
            {{ t('fanReasons.congratsYourTicketIsOnSale') }}
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </ng-template>
</ng-container>